module.exports = __webpack_public_path__ + "static/media/video.48e6141c.svg";